@if (!mobile()) {
<p-button variant="outlined" [rounded]="true" severity="secondary" icon="pi pi-globe"
    styleClass="h-11! w-11! hidden lg:flex dark:border-white dark:text-white" aria-label="{{ 'navbar.changeLanguage' | translate }}"
    title="{{ 'navbar.changeLanguage' | translate }}" (click)="languageMenu.toggle($event)">
</p-button>
} @else {
<a (click)="languageMenu.toggle($event)"
    class="flex items-center gap-3 rounded-xl px-4 py-3 min-h-12 transition hover:bg-gray-50 hover:cursor-pointer">
    <i class="pi pi-globe text-blue-600 text-lg! dark:text-blue-400"></i>
    <div class="flex flex-col ml-1">
        <span class="block text-sm text-gray-900 dark:text-white">{{ 'navbar.changeLanguage' | translate }}</span>
    </div>
    <div class="ml-auto flex gap-5 items-center">
        <span class="text-gray-400">{{
            this.translationService.getCurrentLang().toUpperCase().split('-')[0]
            }}</span>
        <i class="pi pi-chevron-down text-xs text-gray-400 dark:text-white"></i>
    </div>
</a>
}
<p-menu #languageMenu [model]="items" [popup]="true" appendTo="body" />